// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import "@hotwired/turbo-rails"

import "@popperjs/core"
// import "bootstrap"
// import "bootstrap/dist/js/bootstrap.bundle.min.js"; 
import './reports'
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import 'bootstrap-datepicker';
import { TempusDominus } from '@eonasdan/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';

window.TempusDominus = TempusDominus;

import React from 'react';
import ReactDOM from 'react-dom';
import IncidentReportFormApp from "./apps/incident_report_form/app";
import IncidentReportSummaryApp from "./apps/incident_report_summary/app";
import GrantRequestFormApp from "./apps/grant_request_form/app.jsx";
import GrantRequestSummaryApp from "./apps/grant_request_summary/app.jsx";
import RmgSurveyFrontendApp from "./apps/rmg/frontend/app";
import RmgSurveyAdminApp from "./apps/rmg/admin/app.jsx";
import NewSurveyApp from "./apps/rmg/new_survey/app.jsx";
import RmgSurveyAdminPreview from "./apps/rmg/frontend/preview.jsx";
import RmgSurveyReadOnly from "./apps/rmg/frontend/readOnly.jsx";
import OshaExportFormApp from "./apps/osha/export_form/app.jsx";
import OshaIncidentFormApp from "./apps/osha/incident_form/app.jsx";
import OshaLocationFormApp from "./apps/osha/location_form/app.jsx";
import EventAttendeeFormApp from "./apps/event_attendee_form/app.jsx";
import EventFormApp from "./apps/event_form/app.jsx";
import CyberSurveyAdmin from "./apps/cyber/admin/app.jsx";
import CyberSurveyFrontend from "./apps/cyber/frontend/app.jsx";
import CyberNewSurveyApp from "./apps/cyber/new_survey/app.jsx";
import CyberSurveyReadOnly from "./apps/cyber/frontend/readOnly.jsx";
import CyberSurveyAdminPreview from "./apps/cyber/frontend/preview.jsx";
import BusinessContinuityEditDocumentApp from "./apps/business_continuity/edit_document/app.jsx";
import BusinessContinuityDocumentUploadApp from "./apps/business_continuity/document_upload/app.jsx";
import MemberSearchOnRegistration from "./apps/member_search/app.jsx";
import Rails from "@rails/ujs";
Rails.start();

import * as ReactRailsUJS from "react_ujs";

// -------- from rails --------

//require("@rails/ujs").start() // we're still using jquery_ujs
// require("turbo").start()
// require("@rails/activestorage").start() // we're not using this
// require("channels") // not using this
import './add_jquery.js'
import DataTable from 'datatables.net-dt'
// -------- polyfills --------
import 'whatwg-fetch'

// -------- our sprinkles (order matters) --------
require(`./sprinkles/init.js`);
require(`./sprinkles/label_floater.js`);
require(`./sprinkles/data_table.js`);

// -------- our sprinkles (order doesn't matters) --------
require(`./sprinkles/admin_table.js`);
require(`./sprinkles/app.scroll_out.js`);
require(`./sprinkles/automagic_form_submission.js`);
require(`./sprinkles/business_continuity_documents_table.js`);
require(`./sprinkles/documents_table.js`);
require(`./sprinkles/elasticubes_table.js`);
require(`./sprinkles/event_attendee_table.js`);
require(`./sprinkles/event_table.js`);
require(`./sprinkles/grant_requests_table.js`);
require(`./sprinkles/incident_reports_table.js`);
require(`./sprinkles/member_nav.js`);
require(`./sprinkles/non_react_phone_number_inputs.js`);
require(`./sprinkles/osha_incidents_table.js`);
require(`./sprinkles/question_table.js`);
require(`./sprinkles/survey_table.js`);
require(`./sprinkles/cyber_survey_table.js`)
require(`./sprinkles/cyber_question_table.js`)
require(`./sprinkles/sync_organizations.js`);
require(`./sprinkles/user_table.js`);

// -------- react_rails and react_ujs --------
window["incident_report_form/app"] = IncidentReportFormApp;
window["incident_report_summary/app"] = IncidentReportSummaryApp;
window["grant_request_form/app"] = GrantRequestFormApp;
window["grant_request_summary/app"] = GrantRequestSummaryApp;
window["rmg/frontend/app"] = RmgSurveyFrontendApp;
window["rmg/admin/app"] = RmgSurveyAdminApp;
window["rmg/new_survey/app"] = NewSurveyApp;
window["rmg/frontend/readOnly"] = RmgSurveyReadOnly;
window["rmg/frontend/preview"] = RmgSurveyAdminPreview;
window["osha/export_form/app"] = OshaExportFormApp;
window["osha/incident_form/app"] = OshaIncidentFormApp;
window["osha/location_form/app"] = OshaLocationFormApp;
window["event_attendee_form/app"] = EventAttendeeFormApp;
window["event_form/app"] = EventFormApp;
window["cyber/frontend/app"] = CyberSurveyFrontend;
window["cyber/admin/app"] = CyberSurveyAdmin;
window["cyber/new_survey/app"] = CyberNewSurveyApp;
window["cyber/frontend/readOnly"] = CyberSurveyReadOnly;
window["cyber/frontend/preview"] = CyberSurveyAdminPreview;
window["business_continuity/edit_document/app"] = BusinessContinuityEditDocumentApp;
window["business_continuity/document_upload/app"] = BusinessContinuityDocumentUploadApp;
window["member_search/app"] = MemberSearchOnRegistration;

window.Rmg = {
  SurveyFrontendApp: RmgSurveyFrontendApp,
  SurveyAdminApp: RmgSurveyAdminApp,
  NewSurveyApp: NewSurveyApp,
  SurveyReadOnly: RmgSurveyReadOnly,
  SurveyAdminPreview: RmgSurveyAdminPreview
};

window.cyber = {
  CyberSurveyFrontend: CyberSurveyFrontend,
  CyberSurveyAdmin: CyberSurveyAdmin,
  CyberNewSurveyApp: CyberNewSurveyApp,
  CyberSurveyReadOnly: CyberSurveyReadOnly,
  CyberSurveyAdminPreview: CyberSurveyAdminPreview
};

// Create a components object
// const components = {
//   "incident_report_form/app": IncidentReportFormApp,
// };
// let componentsContext = {};
// Object.keys(components).forEach(name => {
//   componentsContext[name] = components[name];
// });
// ReactRailsUJS.getConstructor = name => {
//   return componentsContext[name];
// };
// ReactRailsUJS.handleEvent('turbo:load', ReactRailsUJS.handleMount, false);
// ReactRailsUJS.handleEvent('turbo:frame-load', ReactRailsUJS.handleMount, false);
// ReactRailsUJS.handleEvent('turbo:before-render', ReactRailsUJS.handleUnmount, false);
// ReactRailsUJS.getConstructor = name => { return components[name]; };
// -------- mount a component on click --------
// TODO - might be nice to ditch this. kinda weird to have to require react / react-dom outselves
//        in the handler.
// Make them available globally
window.React = React;
window.ReactDOM = ReactDOM;
// Add this after your window assignments in application.js
document.addEventListener('turbo:load', function() {
  // Force React components to remount
  if (window.ReactRailsUJS) {
    window.ReactRailsUJS.mountComponents();
  }
});

document.addEventListener('turbo:before-cache', function() {
  // Unmount React components before caching
  if (window.ReactRailsUJS) {
    window.ReactRailsUJS.unmountComponents();
  }
});
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, checking for elements...');
  console.log('Elements with mount behavior:', document.querySelectorAll('[data-behavior*="mount-react-component-on-click"]').length);
});

document.addEventListener('turbo:load', function() {
  console.log('Turbo loaded, checking for elements...');
  console.log('Elements with mount behavior:', document.querySelectorAll('[data-behavior*="mount-react-component-on-click"]').length);
});

$(document).on("click", "[data-behavior~=mount-react-component-on-click]", function(event) {
  console.log('Mount behavior clicked!');
  event.preventDefault();

  let props = $(this).data("props")
  console.log('Props:', props);

  props.mount = document.getElementById($(this).data("mount"))
  console.log('Mount element found:', props.mount);

  const componentName = $(this).data("component");
  console.log('Component name:', componentName);
  
  // ✅ Use window[componentName] instead of ReactRailsUJS.getConstructor
  const Component = window[componentName];
  console.log('Component found:', Component);

  if (Component && props.mount) {
    window.ReactDOM.render(
      window.React.createElement(Component, props),
      props.mount
    );
    console.log('Component mounted successfully!');
  } else {
    console.error('Missing component or mount point:', {
      Component: !!Component,
      mount: !!props.mount
    });
  }
});
